import React from "react";
import "./styles.css";

/*
 * Wraps tab content and fades it in on each tab switch. The wrapper is re-keyed
 * on `activeKey`, so React remounts it whenever the active tab changes and the
 * CSS fade animation replays. Use it around whatever a page renders for its
 * currently-selected tab.
 */
const TabFade = ({ activeKey, className = "", style, children }) => (
  <div
    key={activeKey}
    className={`tab-panel-fade ${className}`.trim()}
    style={style}
  >
    {children}
  </div>
);

export default TabFade;
